import { InterfaceIcon, getSvgIcon } from '@helpers/icons';
import { getSrcs } from '@helpers/image';
import { Device, from } from '@helpers/media';
import { FakeButton } from '@stories/Components/Buttons/Button/Button';
import * as React from 'react';
import S from './CtaCard.styles';
const CtaCard = (props) => {
    const mobileSrcs = props.image ? getSrcs(props.image, 768, 375, 6, 328 / 180) : undefined;
    const srcs = props.image ? getSrcs(props.image, 1680, 348, 16, 406 / 271) : undefined;
    return (React.createElement(S.Container, { "data-variant": props.variant, "data-has-image": !!props.image || !!props.icon, ...(props.cta ? { as: 'a', href: props.cta.url, target: props.cta.target } : {}) },
        (props.image || props.icon) && (React.createElement(S.ImageContainer, null,
            props.type === 'image' && srcs && mobileSrcs && (React.createElement("picture", null,
                React.createElement("source", { media: from(Device.Tablet), srcSet: srcs?.srcSet, sizes: props.sizes }),
                React.createElement(S.Image, { src: mobileSrcs.src, srcSet: mobileSrcs.srcSet, alt: props.image?.altText, loading: "lazy", sizes: props.sizes }))),
            props.type === 'icon' && React.createElement(React.Fragment, null, getSvgIcon(props.icon)))),
        React.createElement(S.ContentWrapper, null,
            React.createElement(S.Heading, { as: props.headingType, "data-size": props.titleSize }, props.heading),
            props.subheading && React.createElement(S.Subheading, null, props.subheading),
            props.cta && (React.createElement(FakeButton, { buttonType: "secondary", icon: InterfaceIcon.ArrowRight, iconOnly: true })))));
};
export default CtaCard;
